<div class="animated fadeIn">
  <div class="row">
    <div class="col-sm-12 col-lg-12">
      <div class="card">
        <div class="card-header">
          @if (action =='remove') {
            <strong style="color : red;">Removing Member {{memberToRemove.user.name}} and Migrating Data</strong>
          }
          @if (action =='migrate') {
            <strong>Migrating Data owned by {{memberToRemove.user.name}}</strong>
          }
          <h4>Select Other Member to Migrate all the Data To</h4>
          <ng-select #userSelect [items]="remainingMembers" [selectOnTab]="true" bindLabel="user.name"
            labelForId="memberId" placeholder="Select Member you would like to migrate data to" [(ngModel)]="migrateToUser">
            <ng-template ng-label-tmp let-item="item">
              <app-profile-image classInput="avatar-square" [displayName]="item.user.name"
                [imageFilePath]="item.user.profilePictureUrl">
              </app-profile-image>
              {{item.user.name | titlecase}}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="p-1">
                <div class="mr-3 float-left">
                  <div class="avatar">
                    <app-profile-image classInput="avatar-square" [displayName]="item.user.name"
                      [imageFilePath]="item.user.profilePictureUrl">
                    </app-profile-image>
                  </div>
                </div>
                <div>
                  <small class="text-muted">{{item.user.name | titlecase}}@if (item.accountEmail) {
                    <span
                    >&nbsp;|&nbsp;{{item.accountEmail}}</span>
                  }</small>
                  <small class="text-muted float-right mt-1">{{item.authorizationLevel}}</small>
                </div>
              </div>
            </ng-template>
          </ng-select>
          @if (isLargeAccount) {
            <div class="alert alert-warning mt-3" style="border-left: 4px solid #ff9800; background: #fff3e0;">
              <strong><i class="bi bi-exclamation-triangle-fill me-1"></i> Large Data Volume Detected</strong>
              <p class="mb-0 mt-1">This user owns <strong>{{memberLeadCount | number}}</strong> leads. To avoid disrupting operations, this job will be <strong>scheduled to run at 8:30 PM IST (off-peak hours)</strong>.</p>
            </div>
          }
          <div class="comment-box">
            <h4 style="font-weight: bold; font-style: italic;">You also have an option to mark the user as inactive and disable access. Later as and when needed you can migrate the data to current users.</h4>
          </div>
          <div class="d-flex justify-content-end bd-highlight" style="margin-top: 100px;">
            <button type="submit" mat-raised-button color="primary" (click)="submitRequest()"
            [disabled]="migrateToUser == null">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>